import { render } from "./GenderPolicy.vue?vue&type=template&id=7d34c4b9&ts=true"
import script from "./GenderPolicy.vue?vue&type=script&lang=ts"
export * from "./GenderPolicy.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\laragon\\www\\SDL\\blims\\blims-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__